export default "https://statics.cloudfastin.top/static/v1.27.25.1/store/images/amazon1.png?2bbbd2d96ccab0dfdd798063893fbe26";